import React from 'react';
import Escolhas from './Escolhas';
import Etiqueta from './Etiqueta';

/**
 * SeletorEtiquetas — escolhe uma ou mais etiquetas coloridas (classificação, não situação).
 * etiquetas: [{ id, nome, cor }]. selecionadas: array de ids. Várias podem ficar marcadas.
 */
export default function SeletorEtiquetas({ etiquetas, selecionadas = [], onMudar, rotulo = 'Etiquetas' }) {
  const opcoes = etiquetas.map((e) => ({
    valor: e.id,
    rotulo: <Etiqueta cor={e.cor}>{e.nome}</Etiqueta>,
  }));
  return <Escolhas opcoes={opcoes} selecionados={selecionadas} onMudar={onMudar} rotulo={rotulo} />;
}
